import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import _ from 'lodash';

import { CognitoUser } from 'types';

export const useTokenInfo = (): CognitoUser | null => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const updateUserInfo = async () => {
      try {
        const currentUser = await fetchAuthSession();
        if (currentUser.tokens?.idToken) {
          const userEmail = currentUser?.tokens?.idToken?.payload?.email;
          const transformedPayload = {
            ...currentUser?.tokens?.idToken?.payload,
            email: _.isString(userEmail) ? userEmail.toLowerCase() : '',
          };
          setUserInfo(transformedPayload);
        }
      } catch {
        setUserInfo(null);
      }
    };
    // uncomment these lines if you want to remove all user info at the instant user clicks signout button
    // Hub.listen('auth', updateUserInfo);
    updateUserInfo();
    // return () => Hub.remove('auth', updateUserInfo);
  }, []);

  return userInfo;
};
